<template>
  <div :class="$style.balloon">
    <div :class="$style.balloon__background" />
    <div :class="$style.balloon__message">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'DolphinBalloon',
})
</script>

<style lang="scss" module>
.balloon {
  position: relative;
  padding: 12px 14px 14px;

  &__background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: $color-surface-accent-primary;
    border-radius: $border-radius-v2-rounder;

    &::before {
      $size: 16px;

      position: absolute;
      top: 100%;
      left: 50%;
      width: $size;
      height: $size;
      background-color: $color-surface-accent-primary;
      content: '';
      transform: translate(-50%, calc(-50% - 1px)) rotate(45deg);
    }
  }

  &__message {
    color: $color-text-and-object-high-emphasis-inverse;
    font-size: 12px;
    isolation: isolate;
  }
}
</style>
